import React from 'react'
import useSWRImmutable from 'swr/immutable'

import { getAllDifficultyLevels } from '../../../../api/difficulty-levels'
import Loading from '../../../components/layout/Loading'
import SelectInput from '../../../components/form/SelectInput'
import { useI18N } from '../../../../libraries/i18n/hook'

type Props = {
  onChange: (values: { difficultyLevels: string[] }) => void,
  values?: string[]
}
const DifficultyLevelSelectBox: React.FC<Props> = ({ onChange, values }) => {
  const { t } = useI18N()
  const { data, isLoading } = useSWRImmutable('difficulty-levels', getAllDifficultyLevels)

  if(isLoading) return <Loading />

  const handleChange = (ids: string[]) => {
    onChange({ difficultyLevels: ids })
  }

  const options = data?.map(({ name, id }) => ({ label: name, value: id.toString() }))
  if(!options) return null
  return (
    options && (
      <SelectInput
        isDisabled={options?.length === 0}
        value={options?.filter(level => values?.includes(level.value))}
        name='difficultyLevels'
        label={t('content.difficultyLevel')}
        onChange={handleChange}
        options={options}
        autoMinWidth
      />
    )
  )
}

export default DifficultyLevelSelectBox
